<script setup lang="ts">
import { ref } from 'vue'
import CmsText from '~/layers/cms/app/components/cms/CmsText.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const opened = ref<number | null>(0)

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Teksty/Faq'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}

const component_default_values_2: CmsCustomComponentType = {
  title: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien tytuł' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <CmsCustomComponentList
      :id="component_values?.id?.value"
      v-slot="{ component_values: componentListValues }"
      :cms-data-path="[...props.cmsDataPath, 'component_data', 'faq_list']"
      :open-options="true"
      :component-name="nazwa_komponentu"
      :defaults="component_default_values_2"
      class="min-w-5 min-h-5 px-2xl flex flex-col gap-2.5"
    >
      <AppAccordeon
        v-for="(value, index) in componentListValues"
        :key="JSON.stringify(value)"
        :title="((value?.title?.value ?? value?.title?.default_value) as string)"
        :expanded="opened === index"
        @toggle="opened = opened === index ? null : index"
      >
        <div class="py-3 px-7.5">
          <span class="text-H4 text-Tekst">
            <CmsText
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'faq_list', 'component_data', index, 'text']"
            />
          </span>
        </div>
      </AppAccordeon>
    </CmsCustomComponentList>
  </CmsCustomComponent>
</template>
